/**
 * Privacy Policy JavaScript
 * Loads contact information dynamically from JSON
 */

document.addEventListener('DOMContentLoaded', function() {
    // console.log('Privacy Policy script loaded');
    // console.log('fantastic_windows_vars:', typeof fantastic_windows_vars !== 'undefined' ? fantastic_windows_vars : 'undefined');
    // Load contact information dynamically from JSON
    loadContactInfo();
    // Create copyright and creator section
    createCopyrightAndCreatorSection();
});

function loadContactInfo() {
    const contactInfoContainer = document.getElementById('privacyContactInfo');
    
    if (!contactInfoContainer) {
        console.error('Contact info container not found');
        return;
    }
    
    if (typeof fantastic_windows_vars === 'undefined') {
        console.error('fantastic_windows_vars is not defined');
        contactInfoContainer.innerHTML = `
            <div class="alert alert-danger text-center">
                <i class="fas fa-exclamation-circle me-2"></i>
                JavaScript configuration error. Please refresh the page.
            </div>
        `;
        return;
    }
 
    // console.log('Loading contact info from:', `${fantastic_windows_vars.api_url}/json/contactUs`);
 
    // Fetch contact data from the same API endpoint used by contacts page
    fetch(`${fantastic_windows_vars.api_url}/json/contactUs`)
        .then(response => {
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            return response.json();
        })
        .then(data => {
            if (data && data.contactUsLeftList && data.contactUsLeftList.level) {
                const contactData = data.contactUsLeftList.level;

                // Extract contact information from the JSON structure
                let email = '';
                let phone = '';
                let address = '';
                
                // Find the ul element with contact items
                const ulElement = contactData.find(item => item.element === 'ul' && item.items);
                if (ulElement && ulElement.items) {
                    ulElement.items.forEach(item => {
                        // Check for address (contains location keywords)
                        if (item.text && (item.text.includes('SIDCO') || item.text.includes('IGC') || item.text.includes('Samba'))) {
                            address = item.text;
                        } 
                        // Check for phone (contains phone number patterns)
                        else if (item.text && (item.text.includes('+91') || item.text.includes('phone') || /\d{10}/.test(item.text))) {
                            phone = item.text;
                        } 
                        // Check for email (has mailto link)
                        else if (item.content && Array.isArray(item.content)) {
                            const emailLink = item.content.find(content => content.element === 'a' && content.href && content.href.includes('mailto:'));
                            if (emailLink && emailLink.href) {
                                email = emailLink.href.replace('mailto:', '');
                            }
                        }
                    });
                }

                // Only proceed if we have at least some contact information
                if (email || phone || address) {
                    // Create the contact info HTML
                    const contactHTML = `
                        <div class="row">
                            <div class="col-md-6">
                                <h5 class="text-primary">Fantastic Windows</h5>
                                ${email ? `<p class="mb-2">
                                    <i class="fas fa-envelope me-2"></i>
                                    Email: <a href="mailto:${email}" class="text-decoration-none">${email}</a>
                                </p>` : ''}
                                ${phone ? `<p class="mb-2">
                                    <i class="fas fa-phone me-2"></i>
                                    Phone: ${phone}
                                </p>` : ''}
                            </div>
                            <div class="col-md-6">
                                <h5 class="text-primary">Address</h5>
                                ${address ? `<p class="mb-2">
                                    <i class="fas fa-map-marker-alt me-2"></i>
                                    ${address}
                                </p>` : ''}
                                <p class="mb-2">
                                    <i class="fas fa-clock me-2"></i>
                                    Business Hours: Monday - Friday, 8:00 AM - 6:00 PM
                                </p>
                            </div>
                        </div>
                    `;
                    
                    contactInfoContainer.innerHTML = contactHTML;
                } else {
                    // No contact information found in JSON
                    contactInfoContainer.innerHTML = `
                        <div class="alert alert-warning text-center">
                            <i class="fas fa-exclamation-triangle me-2"></i>
                            Contact information not found in data source. Please check the contact page for current details.
                        </div>
                    `;
                }
            } else {
                // Show error message if JSON structure is not as expected
                contactInfoContainer.innerHTML = `
                    <div class="alert alert-warning text-center">
                        <i class="fas fa-exclamation-triangle me-2"></i>
                        Unable to load contact information. Please check the contact page for current details.
                    </div>
                `;
            }
        })
        .catch(error => {
            console.error('Error loading contact information:', error);
            // Show error message if API call fails
            contactInfoContainer.innerHTML = `
                <div class="alert alert-danger text-center">
                    <i class="fas fa-exclamation-circle me-2"></i>
                    Error loading contact information. Please check the contact page for current details.
                </div>
            `;
        });
}

function createCopyrightAndCreatorSection() {
    const copyrightAndCreatorSection = document.querySelector('#copyright-and-creators-id');
    
    if (copyrightAndCreatorSection) {
        // Create the copyright div with border
        const copyrightAndCreatorDiv = document.createElement('div');
        copyrightAndCreatorDiv.className = 'text-white mb-0 mt-3 pt-3 text-center';
        copyrightAndCreatorDiv.style.borderTop = '1px solid #464646';
        
        // Create left copyright section
        const leftDiv = document.createElement('div');
        leftDiv.className = 'copyright-inline-left';
        leftDiv.innerHTML = `Copyright &copy; ${new Date().getFullYear()}. All rights reserved.`;
        
        // Create right powered by section
        const rightDiv = document.createElement('div');
        rightDiv.className = 'copyright-inline-right';
        rightDiv.innerHTML = "Powered by: <a class='text-white btn btn-link' target='_blank' href='https://claricesystems.com/'>Clarice Systems</a>";
        
        // Append sections to the main div
        copyrightAndCreatorDiv.appendChild(leftDiv);
        copyrightAndCreatorDiv.appendChild(rightDiv);
        
        // Append to the footer section
        copyrightAndCreatorSection.appendChild(copyrightAndCreatorDiv);
    }
}